import getCmp from "./helpers/cmpHelpers";

let umeGlobalTabIndex = {};
const consentmanagerHandleBackground = async () => {
    let cmp = getCmp();
    let count = 0;
    while(cmp === null && count < 100){
        cmp = getCmp();
        count++;
    }
    if (cmp !== null) {
        cmp('addEventListener', ['consent', handleConsentScreen, false], null)
        cmp('addEventListener', ['consentscreencustom', handleConsentScreen, false], null)
        cmp('addEventListener', ['consentscreen', handleConsentScreen, false], null)
      //  const consentData = await waitForCMPProperty('getCMPData');
        /*if(consentData !== undefined && consentData !== null && consentData.consentstring === ''){
            console.log('lock')
            document.body.classList.add('modal-open');
            umeGlobalTabIndex = lockTabIndex();
        }*/

        waitForElement('#cmpwrapper').then((element) => {
            const dialog = element.shadowRoot.querySelector('#cmpbox');
            if(dialog !== null && dialog !== undefined && dialog.classList.contains('cmpboxclosed')){
                if (umeGlobalTabIndex && Object.keys(umeGlobalTabIndex).length > 0) {
                    document.body.classList.remove('modal-open');
                    unlockTabIndex(umeGlobalTabIndex);
                }
            }
        }).catch((error) => {
            console.error('Error:', error);
        });
    }
}
export default consentmanagerHandleBackground;

const handleConsentScreen = (e, o) => {
    if (e === 'consentscreencustom' || e === 'consentscreen') {
        document.body.classList.add('modal-open');
        umeGlobalTabIndex = lockTabIndex();
    }
    if (e === 'consent') {
        document.body.classList.remove('modal-open');
        if(window.location.hash && window.location.hash.length > 1){
            let targetId = window.location.hash.replace('#', '');
            const scrollTo = document.getElementById(targetId);
            if(scrollTo !== undefined && scrollTo !== null){
                scrollTo.scrollIntoView();
            }
        }
        if (umeGlobalTabIndex && Object.keys(umeGlobalTabIndex).length > 0) {
            unlockTabIndex(umeGlobalTabIndex);
        }

    }
}
const lockTabIndex = () => {
    const selector =
        'div.cmppreviewroot, a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
    const tabElements = document.querySelectorAll(selector);
    let tabArray = Array.from(tabElements)
        .map((elem) => {

            const tabIndex = elem.hasAttribute("tabindex")
                ? elem.getAttribute("tabindex")
                : null;

            elem.setAttribute("tabindex", -1);
            return {elem, tabIndex};
        })
    return tabArray;
}
const unlockTabIndex = (oldState) => {
    oldState.forEach(({elem, tabIndex}) => {
        if (tabIndex === null) {
            elem.removeAttribute("tabindex");
        } else {
            elem.setAttribute("tabindex", tabIndex);
        }
    });
}

function waitForElement(selector) {
    return new Promise((resolve) => {
        const observer = new MutationObserver((mutations, observer) => {
            const element = document.querySelector(selector);
            if (element) {
                observer.disconnect();
                resolve(element);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    });
}
function waitForCMPProperty(property) {
    return new Promise((resolve) => {

            let element = __cmp(property);
            const interval = setInterval(() =>{
                element = __cmp(property);
                if (element !== undefined) {
                    clearInterval(interval)
                    resolve(element);
                }
            }, 50)



    });
}